import { render, staticRenderFns } from "./ReplaceMaterialWithoutCode.vue?vue&type=template&id=5840b4da"
import script from "./ReplaceMaterialWithoutCode.vue?vue&type=script&lang=js"
export * from "./ReplaceMaterialWithoutCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports